import TabelaNcmIBSCBSService from "@/services/TabelaNcmIBSCBSService";

export const tabelaNcmIBSCBS = {
  namespaced: true,
  state: {
    tabelaNcmIBSCBS: {},
  },
  actions: {
    getTabelaNcmIBSCBS({ commit }, payload) {
      return TabelaNcmIBSCBSService.GetTabelaNcmIBSCBS(payload).then(
        (tabelaNcmIBSCBS) => {
          return Promise.resolve(tabelaNcmIBSCBS);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTabelaNcmIBSCBS({ commit }, payload) {
      return TabelaNcmIBSCBSService.PostTabelaNcmIBSCBS(payload).then(
        (tabelaNcmIBSCBS) => {
          return Promise.resolve(tabelaNcmIBSCBS);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTabelaNcmIBSCBS({ commit }, payload) {
      return TabelaNcmIBSCBSService.PutTabelaNcmIBSCBS(payload).then(
        (tabelaNcmIBSCBS) => {
          return Promise.resolve(tabelaNcmIBSCBS);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTabelaNcmIBSCBS({ commit }, payload) {
      return TabelaNcmIBSCBSService.DeleteTabelaNcmIBSCBS(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTabelaNcmIBSCBSOData({ commit }, payload) {
      return TabelaNcmIBSCBSService.GetTabelaNcmIBSCBSOData(payload).then(
        (tabelaNcmIBSCBS) => {
          return Promise.resolve(tabelaNcmIBSCBS);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    atualizarTabelaNcmIBSCBS({ commit }, payload) {
      return TabelaNcmIBSCBSService.AtualizarTabelaNcmIBSCBS(payload).then(
        (tabelaNcmIBSCBS) => {
          return Promise.resolve(tabelaNcmIBSCBS);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default tabelaNcmIBSCBS;
